import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';

// W-0779 — Filtros de escopo GE x GrupoGE mutuamente exclusivos (Q-07=A).
// Fonte: UListaRazao.pas:473 (LgeChange limpa GrupoGE) / 489 (LGrupoGEChange limpa GE).
// Selecionar um campo limpa o outro (componente reativo — replica UX Delphi).
// Obs.: o backend recebe codigo_grupo_empresa / codigo_grupo_ge como inteiros opcionais;
// nao ha endpoint de combo de GE proprio desta demanda (reuso de selector pendente — [VALIDAR-FASE4]).
const FiltrosEscopo = ({ codigoGrupoEmpresa, codigoGrupoGE, onChange }) => {
  const parseNum = (valor) => {
    if (valor === '' || valor == null) return null;
    const n = Number(valor);
    return Number.isNaN(n) ? null : n;
  };

  const handleGe = (e) => {
    const valor = parseNum(e.target.value);
    // Selecionar GE limpa GrupoGE (exclusao mutua).
    onChange({ codigoGrupoEmpresa: valor, codigoGrupoGE: valor != null ? null : codigoGrupoGE });
  };

  const handleGrupoGe = (e) => {
    const valor = parseNum(e.target.value);
    // Selecionar GrupoGE limpa GE (exclusao mutua).
    onChange({ codigoGrupoGE: valor, codigoGrupoEmpresa: valor != null ? null : codigoGrupoEmpresa });
  };

  return (
    <Row className="mb-3">
      <Col xs={12} md={6} lg={4}>
        <Form.Group className="mb-0">
          <Form.Label className="small mb-1">GE (Grupo Empresa)</Form.Label>
          <Form.Control
            type="number"
            min={1}
            value={codigoGrupoEmpresa == null ? '' : codigoGrupoEmpresa}
            onChange={handleGe}
            disabled={codigoGrupoGE != null}
            placeholder="Código do GE"
          />
        </Form.Group>
      </Col>
      <Col xs={12} md={6} lg={4}>
        <Form.Group className="mb-0">
          <Form.Label className="small mb-1">Grupo de GE</Form.Label>
          <Form.Control
            type="number"
            min={1}
            value={codigoGrupoGE == null ? '' : codigoGrupoGE}
            onChange={handleGrupoGe}
            disabled={codigoGrupoEmpresa != null}
            placeholder="Código do Grupo de GE"
          />
        </Form.Group>
      </Col>
    </Row>
  );
};

export default FiltrosEscopo;
